export default "__VITE_ASSET__CdRTZuky__"